import React from 'react'
import PropTypes from 'prop-types'

import { Form, Input, Select } from 'antd'

export const BinForm = ({
  data,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  options
}) => {
  return (
    <Form layout="vertical">
      <Form.Item
        label="Bin ID"
        help={touched.binId && errors.binId ? errors.binId : ''}
        validateStatus={touched.binId && errors.binId ? 'error' : undefined}
      >
        <Input
          name="binId"
          placeholder="Bin ID"
          value={values.binId}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Form.Item>

      <Form.Item
        label="Password"
        help={touched.password && errors.password ? errors.password : ''}
        validateStatus={
          touched.password && errors.password ? 'error' : undefined
        }
      >
        <Input.Password
          name="password"
          placeholder="อย่างน้อย 6 ตัวอักษร"
          type="password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          disabled={Boolean(data.hero)}
        />
      </Form.Item>

      <Form.Item
        label="Mac Address"
        help={touched.macAddress && errors.macAddress ? errors.macAddress : ''}
        validateStatus={
          touched.macAddress && errors.macAddress ? 'error' : undefined
        }
      >
        <Input
          name="macAddress"
          placeholder="Mac Address"
          value={values.macAddress}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Form.Item>

      <Form.Item
        label="Status"
        help={touched.status && errors.status ? errors.status : ''}
        validateStatus={touched.status && errors.status ? 'error' : undefined}
      >
        <Select
          placeholder="Select Status"
          name="status"
          value={values.status}
          onChange={handleChange('status')}
        >
          {options &&
            options.options &&
            options.options.map(status => (
              <Select.Option key={status.name}>{status.name}</Select.Option>
            ))}
        </Select>
      </Form.Item>
    </Form>
  )
}

BinForm.propTypes = {
  data: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired
}

export default BinForm



// WEBPACK FOOTER //
// ./src/pages/Bin/components/BinForm/index.js